import type { UIMessage } from '../api/chat/types';
import type { GatewayChatResponse, SSEEvent } from './types';

export function normalizeGatewayResponse(response: GatewayChatResponse): {
  assistantMessage?: UIMessage;
  error?: string;
  pendingAction?: GatewayChatResponse['pendingAction'];
  executingSteps?: GatewayChatResponse['executingSteps'];
} {
  switch (response.type) {
    case 'text':
      if (response.message) {
        return {
          assistantMessage: {
            id: `assistant-${Date.now()}`,
            role: 'assistant',
            content: response.message.content,
            timestamp: Math.floor(Date.now() / 1000),
          },
        };
      }
      return {};

    case 'confirmation_required':
      return { pendingAction: response.pendingAction };

    case 'tool_executing':
      return { executingSteps: response.executingSteps };

    case 'error':
      return { error: response.error || 'Gateway error' };

    default:
      return {};
  }
}

export function normalizeSSEToMessage(event: SSEEvent): UIMessage | null {
  if (event.event === 'response' && event.data?.message) {
    return {
      id: `assistant-${Date.now()}`,
      role: 'assistant',
      content: event.data.message.content || '',
      timestamp: Math.floor(Date.now() / 1000),
    };
  }
  return null;
}
